import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { formikValidation, formikinitialvalues } from "../../../../../CommonFunction/common";
import PaymentProcessTable from "./AddPaymentProcessTable";

import "jspdf-autotable";

const AddPaymentProcessSection = ({
  fielddata,
  inputfields,
  Type,
  name,

  selectedRows,
  handleTablePaymentChange,
}) => {
  const [fields, setfields] = useState(inputfields);
  const [alldata, setalldata] = useState({});
  const [selectedpayments, setSelectedPayments] = useState(selectedRows ? [...selectedRows] : []);
  useEffect(() => {
    if (selectedRows) {
      setSelectedPayments([...selectedRows]);
    }
  }, [selectedRows]);
  const onPaymentChange = (event, id, name) => {
    let updatedPayment = selectedpayments.map((el, i) => {
      if (id === el._id) {
        return { ...el, [name]: event.target.value };
      }
      return el;
    });
    handleTablePaymentChange(updatedPayment);
    setSelectedPayments(updatedPayment);
  };

  const handlePaymentDelete = (id) => {
    if (selectedpayments.length >= 1) {
      let temp = selectedpayments.filter((e) => {
        return e._id !== id;
      });
      handleTablePaymentChange(temp);

      setSelectedPayments(temp);
    }
  };

  useEffect(() => {
    if (fielddata) {
      let arr = [];
      //Note : This is Not Needed remove this
      for (var a = 0; a < fields.length; a++) {
        if (fields[a].name === "Sidebyside" || fields[a].name === "Bank details") {
          for (var b = 0; b < fields[a].Subfields.length; b++) {
            arr.push({
              [fields[a].Subfields[b].name]: fielddata[fields[a].Subfields[b].name],
            });
            formik.setFieldValue(fields[a].Subfields[b].name, fielddata[fields[a].Subfields[b].name]);
          }
        } else {
          arr.push({ [fields[a].name]: fielddata[fields[a].name] });
          formik.setFieldValue(fields[a].name, fielddata[fields[a].name]);
        }
      }
      let obj = {};

      for (var l = 0; l < arr.length; l++) {
        let temp = arr[l];
        for (var key in temp) {
          obj[key] = temp[key];
        }
      }
      if (obj) {
        setalldata(obj);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fielddata]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: "Add_FormFieldData",
      payload: { data: alldata, key: Type },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alldata]);
  const validate = (values) => {
    setalldata(values);
  };
  let formik = useFormik({
    initialValues: formikinitialvalues(inputfields),
    validationSchema: formikValidation(inputfields),

    validate,
    onSubmit: (values) => {
      console.log("");
    },
  });
  useEffect(() => {
    setfields(inputfields);
  }, [inputfields]);

  return (
    <>
      <div>
        <form onSubmit={formik.handleSubmit} autoComplete="off" className="journalHeader2"></form>
      </div>
      <div className="ProcesstableContainer">
        <table id="Table">
          <thead>
            <tr className="headerRow">
              <th className="">Account No</th>
              <th className="">Account Type</th>
              <th className="">Bank Name</th>
              <th className="">Bank IFSE Code</th>
              <th className="">Party Name</th>
              <th className="">Reference NO</th>
              <th className="">Amount</th>
              <th className="">Type Of Payment</th>
              <th className="">Date</th>
              <th className="">Narration</th>
              <th className="">Remarks</th>
            </tr>
          </thead>
          <tbody>
            {selectedpayments?.map((el, i) => {
              return (
                <PaymentProcessTable
                  i={i}
                  el={el}
                  name={name}
                  formik={formik}
                  rowData={el.row_id}
                  id={el.row_id}
                  onPaymentChange={onPaymentChange}
                  handlePaymentDelete={handlePaymentDelete}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AddPaymentProcessSection;
